import { render, staticRenderFns } from "./route-transport.vue?vue&type=template&id=4d5f48b8"
import script from "./route-transport.vue?vue&type=script&lang=js"
export * from "./route-transport.vue?vue&type=script&lang=js"
import style0 from "./route-transport.vue?vue&type=style&index=0&id=4d5f48b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports